
import { Checkbox, Col, Form, Input, InputNumber, Radio, Row, Select } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getMerchantCode, getMerchantCode2, shallowEqualIgnoreOrder } from '../../utils/commonFun';
import { getFieldOptionsByCode } from '../../../../api/customForm';
import { getBorderRadiusValue } from '../../utils/borderRadius';
import { getCheckboxCheckedCss, getCheckboxOptionWrapperStyle } from '../../utils/checkboxOptionStyle';
import { getFormItemLabelNode } from '../../utils/formLabel';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

export const CheckboxPropsDefaults = {
    label: '',
    name: '',
    isGroup: 'Yes',
    inline: 'Yes',
    optionGap: 8,
    options: [],
    checkedOptions: [],
    checked: false,
    checkedLabel: '',
    link: '',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false,
};
export const FormCheckbox = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var optionLabelStyle = {
        color: (_bb = style === null || style === void 0 ? void 0 : style.optionLabelColor) !== null && _bb !== void 0 ? _bb : undefined,
        fontSize: (_cc = style === null || style === void 0 ? void 0 : style?.optionLabelFontSize) !== null && _cc !== void 0 ? (isMobile ? _cc/1.1 : _cc) : undefined,
        fontWeight: (_dd = style === null || style === void 0 ? void 0 : style.optionLabelFontWeight) !== null && _dd !== void 0 ? _dd : undefined,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : CheckboxPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : CheckboxPropsDefaults.name;
    var isGroup = (_i = props === null || props === void 0 ? void 0 : props.isGroup) !== null && _i !== void 0 ? _i : CheckboxPropsDefaults.isGroup;
    var options = (_j = props === null || props === void 0 ? void 0 : props.options) !== null && _j !== void 0 ? _j : CheckboxPropsDefaults.options;
    var checkedLabel = (_l = props === null || props === void 0 ? void 0 : props.checkedLabel) !== null && _l !== void 0 ? _l : CheckboxPropsDefaults.checkedLabel;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : CheckboxPropsDefaults.required;
    var link = (_n = props === null || props === void 0 ? void 0 : props.link) !== null && _n !== void 0 ? _n : CheckboxPropsDefaults.link;
    var visible = (_o = props === null || props === void 0 ? void 0 : props.visible) !== null && _o !== void 0 ? _o : CheckboxPropsDefaults.visible;
    var disabled = (_p = props === null || props === void 0 ? void 0 : props.disabled) !== null && _p !== void 0 ? _p : CheckboxPropsDefaults.disabled;
    
    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    const inline = (_i = formStyle === null || formStyle === void 0 ? void 0 : formStyle.inline) !== null && _i !== void 0 ? _i : CheckboxPropsDefaults.inline;
    const optionGap = formStyle?.optionGap !== null && formStyle?.optionGap !== void 0 ? formStyle?.optionGap : CheckboxPropsDefaults.optionGap;

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;

    const [fieldHidden, setFieldHidden] = useState(false);
    const [fieldLoading, setFieldLoading] = useState(false);
    const [lastDependFields, setLastDependFields] = useState({});
    const [dependFields, setDependFields] = useState({});
    const [getOptions, setGetOptions] = useState(_a?.props?.options || []);

    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        const fetchData = async () => {
            let res = [];
            if(_a?.fieldSource?.type === 'api' && _a?.fCode) {
                //如果options是通过api获取，走这里�?
                if(!fieldLoading) {
                    let dependValues = {};
                    let fullField = true;
                    if(_a?.fieldSource?.depends?.length) {
                        //需要获取其他字段的值来决定options，才发请�?
                        _a?.fieldSource?.depends?.forEach(item=>{
                            if(!dependFields[item.fromField]) {
                                fullField = false;
                            }
                            else if((dependFields[item.fromField]?.isRequired && dependFields[item.fromField]?.value) || !dependFields[item.fromField]?.isRequired) {
                                dependValues[item.targetParam] = dependFields[item.fromField]?.value;
                            }
                            else {
                                fullField = false;
                            }
                        })
                    }
                    if(fullField) {
                        setFieldLoading(true);
                        const merchantCode = getMerchantCode(_a?.cmCode, 'form');
                        const getRes = await getFieldOptionsByCode({
                            "formCode": _a?.fCode,
                            "fieldCode": name,
                            "dependValues": dependValues
                        }, merchantCode ? merchantCode : getMerchantCode2(_a?.cmCode), merchantCode ? null : 'form').catch(error => {
                            return null; // 必须 return，否�?getRes �?undefined
                        });
                        setFieldLoading(false);
                        if(getRes?.options) {
                            res = getRes.options.filter(item=>!item.disabled);
                        }
                    }
                }
            }
            else {
                //原来获取options的方�?
                options?.forEach(item=>{
                    if(item.isRely && item.relyField) {
                        if(_a?.allFieldValues[item.relyField]?.value === item.relyValue) {
                            res.push(item)
                        }
                    }
                    else res.push(item);
                })
            }
            setGetOptions(res);
        };
        
        fetchData();
    }, [options, _a?.fieldSource?.type, _a?.fCode,
        _a?.fieldSource?.type === 'api' ? (_a?.fieldSource?.depends?.length ? dependFields : null) : _a?.allFieldValues
    ])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
        if(_a?.fieldSource?.type === 'api' && _a?.fieldSource?.depends?.length) {
            let depend_fields = {};
            _a?.fieldSource?.depends?.forEach(item=>{
                depend_fields[item.fromField] = _a?.allFieldValues[item.fromField];
            })
            if (!shallowEqualIgnoreOrder(lastDependFields, depend_fields)) {
                setDependFields(depend_fields);
                setLastDependFields(depend_fields);
            }
        }
    }, [_a?.fieldSource, _a?.allFieldValues])

    useEffect(()=>{
        //hiddenOnly字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    const formItemLabel = getFormItemLabelNode(label, required, labelStyle, item_layout === 'vertical' && item_colon);
    const optionWrapperStyle = getCheckboxOptionWrapperStyle(style, isMobile);
    const optionClassName = 'checkbox-option-style-preview';
    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <style>{getCheckboxCheckedCss(optionClassName, style?.optionCheckedBackgroundColor)}</style>
        {
            isGroup === 'Yes' ? <Form.Item
                name={name}
                label={formItemLabel}
                rules={required ? [{ required: true, message: requiredText}] : []}
                valuePropName="checked"
            >
                <Checkbox.Group
                    style={{
                        display: 'flex',
                        flexDirection: inline === 'Yes' ? 'row' : 'column',
                        gap: optionGap
                    }}
                    onChange={(val)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: val,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    disabled={disabled}
                    >
                        {
                            getOptions?.map((item, ind)=>{
                            return <div key={ind} style={optionWrapperStyle}>
                                <Checkbox className={optionClassName} value={item.value}>
                                    <p
                                        style={optionLabelStyle}
                                    >{item.label}</p>
                                </Checkbox>
                            </div>
                        })
                    }
                </Checkbox.Group>   
            </Form.Item> : <Form.Item
                name={name}
                label={formItemLabel}
                rules={required ? [{ required: true, message: requiredText}] : []}
                valuePropName="checked"
            >
                <div style={optionWrapperStyle}>
                    <Checkbox
                        className={optionClassName}
                        onChange={(val)=>{
                            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                                ...prevData,
                                [name]: {
                                    value: val.target.checked,
                                    isRequired: prevData[name]?.isRequired,
                                    type: prevData[name]?.type
                                }
                            }))
                        }}
                        disabled={disabled}
                    >
                        {
                            link && link.trim() ? <a href={link} target='_blank' rel="noreferrer"
                                style={optionLabelStyle}
                            >{checkedLabel}</a> : <p
                                style={optionLabelStyle}
                            >{checkedLabel}</p>
                        }
                    </Checkbox>
                </div>
            </Form.Item>
        }
    </div>
}




